import {AnalyticsVisualizationOutlierSetting as OutlierSetting} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';

type OutlierConfig = NonNullable<
  ExtractByTypename<
    AnalyticsVisualization['parameters'],
    'AnalyticsVisualizationScatterPlotParametersNode'
  >['outlierConfig']
>;

export function getOutlierSetting(outlierConfig: OutlierConfig | null): OutlierSetting | null {
  return outlierConfig?.outlierSetting ?? null;
}
